import { Head } from '@inertiajs/react'
import {
  Box,
  Container,
  Typography,
  Grid,
  Avatar,
  ThemeProvider
} from '@mui/material'
import { Navigation } from '../../components'
import theme from '../../styles/theme'
import maryland from '../../assets/maryland.svg'
import me from '../../assets/me.png'

export default function AboutPage() {
  return (
    <ThemeProvider theme={theme}>
      <Head title="About Us - HeyyProperty" />

      <Navigation />

      {/* Hero Section */}
      <Box sx={{ bgcolor: 'white', pt: 12, pb: 6 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', maxWidth: 600, mx: 'auto' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3, gap: 2 }}>
              <Typography
                variant="h2"
                component="h1"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: '2rem', sm: '2.5rem' },
                  color: 'grey.900'
                }}
              >
                About Us
              </Typography>
              
              {/* Maryland Flag */}
              <img 
                src={maryland} 
                alt="Maryland flag"
                style={{
                  width: '60px',
                  height: '60px',
                  objectFit: 'contain'
                }}
              />
            </Box>
            
            <Typography
              variant="h6"
              sx={{
                textAlign: 'left',
                color: 'grey.600',
                fontWeight: 400,
                fontSize: '1.125rem'
              }}
            >
              Where great landlords and tenants meet. On their terms, with ease.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Founder Section */}
      <Box sx={{ py: 6, bgcolor: 'grey.50' }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 2 } }}>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Typography
                  variant="h3"
                  component="h2"
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: '1.875rem', sm: '2.25rem' },
                    color: 'grey.900',
                    mb: 3
                  }}
                >
                  Meet the Founder
                </Typography>
                <Typography
                  variant="body1"
                  textAlign="left"
                  sx={{
                    color: 'grey.700',
                    fontSize: '1.125rem',
                    lineHeight: 1.7,
                    mb: 4
                  }}
                >
                  I'm a Baltimore landlord and the founder of HeyyProperty. Originally from Boston,
                  I fell in love with this city, the people, the food (shoutout to Ekiben), and the culture.
                  Baltimore is America's most underrated city. It's a city for the underdogs,
                  and there's no other place I'd rather launch a startup than right here in Maryland.


                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 1 } }}>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Avatar
                  src={me}
                  alt="Founder of HeyyProperty"
                  sx={{
                    width: { xs: 280, sm: 320 },
                    height: { xs: 280, sm: 320 },
                    border: '4px solid white',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Mission Section */}
      <Box sx={{ py: 6, bgcolor: 'white' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: { xs: 'center', md: 'left' }, maxWidth: 800, mx: 'auto' }}>
            <Typography
              variant="h3"
              component="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '1.875rem', sm: '2.25rem' },
                color: 'grey.900',
                mb: 4
              }}
            >
              Our Mission
            </Typography>
            <Typography
              variant="body1"
              textAlign="left"
              sx={{
                color: 'grey.700',
                fontSize: '1.125rem',
                lineHeight: 1.7,
                mb: 4
              }}
            >
              AI is about to transform how people rent. Our mission stays simple. We use AI to make it easier than ever for great landlords and tenants to connect.
            </Typography>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  )
}
